import React from 'react';
import { FilePenLine } from 'lucide-react';
import { useLocation } from 'react-router-dom';

import { Bloc } from '@mairistem/administres-utils';
import { Button } from '@mairistem/composants';

import SaisieEvenementModal from './Creation/SaisieEvenementModal';
import SaisieMentionModal from './Creation/SaisieMentionModal';

interface BlocCreationProps {
  style?: React.CSSProperties;
}

const BlocCreation = (props: BlocCreationProps) => {
  const { style } = props;

  const location = useLocation();

  // La modale de saisie d'événement peut être ouverte automatiquement depuis une autre
  // page via le paramètre d'URL `openSaisieEvenement` (ex. retour de l'assistant).
  const [openSaisieEvenement, setOpenSaisieEvenement] = React.useState(
    () =>
      new URLSearchParams(location.search).get('openSaisieEvenement') === '1',
  );
  const [openSaisieMention, setOpenSaisieMention] = React.useState(false);

  const handleOpenSaisieEvenement = React.useCallback(() => {
    setOpenSaisieEvenement(true);
  }, []);

  const handleCloseSaisieEvenement = React.useCallback(() => {
    setOpenSaisieEvenement(false);
  }, []);

  const handleOpenSaisieMention = React.useCallback(() => {
    setOpenSaisieMention(true);
  }, []);

  const handleCloseSaisieMention = React.useCallback(() => {
    setOpenSaisieMention(false);
  }, []);

  return (
    <Bloc
      icon={<FilePenLine />}
      header="Saisir un événement / une mention"
      style={style}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          flexDirection: 'column',
          gap: '4em',
        }}
      >
        <Button
          primary
          icon="plus"
          color="blue"
          size="big"
          content="Saisir un événement"
          onClick={handleOpenSaisieEvenement}
          className="custom-blue-button"
          style={{
            width: '50%',
            borderRadius: '8px',
          }}
        />
        <Button
          primary
          icon="plus"
          color="blue"
          size="big"
          content="Saisir une mention"
          onClick={handleOpenSaisieMention}
          className="custom-blue-button"
          style={{
            width: '50%',
            borderRadius: '8px',
          }}
        />
      </div>
      <SaisieEvenementModal
        open={openSaisieEvenement}
        title="Sélection du type d'acte à créer"
        onClose={handleCloseSaisieEvenement}
      />
      <SaisieMentionModal
        open={openSaisieMention}
        title="Saisir une mention"
        onClose={handleCloseSaisieMention}
      />
    </Bloc>
  );
};

export default BlocCreation;
